import { CURRENCY_CENTS_COUNT, CURRENCY_SIGN, CURRENT_LOCALE } from 'src/constants';

const LocaleString = {
  en: 'en-US',
  he: 'he-IL',
};

export function formatMoney(data: number, withCents: boolean = false) {
  let numericPart;

  if (!data) {
    numericPart = '0';
  } else {
    const preValue = withCents
      ? data / CURRENCY_CENTS_COUNT
      : Math.trunc(data / CURRENCY_CENTS_COUNT);

    const options = withCents
      ? {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }
      : { maximumFractionDigits: 0 };

    numericPart = preValue.toLocaleString(LocaleString[CURRENT_LOCALE], options);
  }

  return `${CURRENCY_SIGN[CURRENT_LOCALE]}${numericPart}`;
}
